import { api } from '@/shared/api-client/client'

export interface AuthUser {
  id: string
  email: string | null
  tg_id: number | null
  tg_username: string | null
  plan: string
  /** Демо-аккаунт без регистрации. */
  is_anonymous: boolean
  /** Сколько бесплатных скачиваний осталось. null — обычный аккаунт. */
  anon_downloads_left: number | null
}

export interface RegisterPayload {
  email: string
  password: string
}

export interface LoginPayload {
  email: string
  password: string
}

export interface TelegramAuthPayload {
  id: number
  first_name?: string
  last_name?: string
  username?: string
  photo_url?: string
  auth_date: number
  hash: string
}

export const authApi = {
  /** Демо-режим без регистрации: кнопка «Попробовать» на лендинге. */
  anonymous: () =>
    api.post<AuthUser>('/api/auth/anonymous', {}),

  /**
   * Регистрация. Если активна анонимная сессия — сервер конвертирует её
   * в полноценный аккаунт, раскладка и файлы сохраняются.
   */
  register: (body: RegisterPayload) =>
    api.post<AuthUser>('/api/auth/register', body),

  login: (body: LoginPayload) =>
    api.post<AuthUser>('/api/auth/login', body),

  refresh: () =>
    api.post<AuthUser>('/api/auth/refresh', {}),

  logout: () =>
    api.post<void>('/api/auth/logout', {}),

  me: () =>
    api.get<AuthUser>('/api/auth/me'),

  telegramCallback: (body: TelegramAuthPayload) =>
    api.post<AuthUser>('/api/auth/tg/callback', body),
}
